import { DEFAULT_POLLING_INTERVAL } from './misc'

export const DEFAULT_INCIDENCE_RATE = 100
export const FEASIBILITY_POLL_INTERVAL = DEFAULT_POLLING_INTERVAL
export const DEFAULT_FEASIBILITY_LENGTH_OF_INTERVIEW = 5
